import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

const Banner = styled.header`
  display: block;
  background-color: #F1F3F8;
  width: 100%;
  z-index: 210;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  ${props => props.theme.isXXLarge && `
    width: 1200px;
  `};
  ${props => props.theme.isXLarge && `
    width: 953px;
  `};
  ${props => props.theme.isLarge && `
    width: 85%;
  `};
  ${props => props.theme.isMobileOrTablet && `
    width: 100%;
  `};
  padding: ${props => (props.theme.isMobileOrTablet ? '22px 20px 26px 20px' : '36px 0 40px 0')};
`;

const Headline = styled.h5`
  color: ${props => props.theme.primaryColor};
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
`;

const SecondaryHeadline = styled(Headline)`
  color: #627484;
`;

const Name = styled.h1`
  color: ${props => props.theme.bodyColor};
  display: flex;
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  ${props => (props.theme.isMobileOrTablet ? `
    font-size: 34px;
    line-height: 44px;
    margin: 10px 0 10px 0;
  ` : `
    font-size: 40px;
    line-height: 52px;
    margin: 0;
  `)};
`;

const QuotedName = styled.span`
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
`;

const Desc = styled.p`
  color: #627484;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 14px;
  line-height: ${props => (props.theme.isMobileOrTablet ? 18 : 22)}px;
  margin: 0;
`;

export default function Header(props) {
  const mediaQueries = {
    isXXLarge: useMediaQuery({ query: '(min-width: 1366px)' }),
    isXLarge: useMediaQuery({ query: '(min-width: 1025px)' }),
    isLarge: useMediaQuery({ query: '(min-width: 769px)' }),
    isMobileOrTablet: useMediaQuery({ query: '(max-width: 768px)' }),
  };
  const {
    headline, name, description, quoteName, secondaryHeadline,
  } = props;

  return (
    <ThemeProvider theme={{ ...theme, ...mediaQueries }}>
      <Banner>
        <Container>
          { secondaryHeadline
            ? <SecondaryHeadline dangerouslySetInnerHTML={{ __html: headline }} />
            : <Headline dangerouslySetInnerHTML={{ __html: headline }} /> }
          {
            quoteName
              ? (
                <Name>
                  {'\u201c'}
                  <QuotedName>{name}</QuotedName>
                  {'\u201d'}
                </Name>
              )
              : <Name>{name}</Name>
          }
          {description && <Desc className="description">{description}</Desc>}
        </Container>
      </Banner>
    </ThemeProvider>
  );
}

Header.propTypes = {
  headline: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  quoteName: PropTypes.bool,
  secondaryHeadline: PropTypes.bool,
};

Header.defaultProps = {
  description: null,
  quoteName: false,
  secondaryHeadline: false,
};
